module.exports = __webpack_public_path__ + "img/062-namibia.f33a3141.svg";